export default __webpack_public_path__ + "static/media/TBREELrechts.ae7b8be6.png";